import { Component, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DynamicField } from '@shared/components/dynamic-form/models/field';
import { RichTextEditorComponent } from '@shared/components/rich-text-editor/rich-text-editor.component';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'app-rich-text-editor-field',
  imports: [RichTextEditorComponent, SharedModule],
  templateUrl: './rich-text-editor-field.component.html',
})
export class RichTextEditorFieldComponent {
  field = input.required<DynamicField>();
  form = input.required<FormGroup>();
  editable = input<boolean>(true);
}
